import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useChangePassword } from '@/lib/queries';
import { useAuthStore } from '@/store/auth.store';

export function ChangePasswordPage() {
  const [currentPassword, setCurrent] = useState('');
  const [newPassword, setNew] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const mut = useChangePassword();
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const setSession = useAuthStore((s) => s.setSession);
  const token = useAuthStore((s) => s.token);
  const refreshToken = useAuthStore((s) => s.refreshToken);

  const forced = !!user?.mustChangePassword;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (newPassword.length < 8) {
      setError('La nueva contraseña debe tener al menos 8 caracteres');
      return;
    }
    if (newPassword !== confirm) {
      setError('Las contraseñas no coinciden');
      return;
    }
    try {
      await mut.mutateAsync({ currentPassword, newPassword });
      // Limpia la bandera mustChangePassword en el store local
      if (user && token && refreshToken) {
        setSession({ ...user, mustChangePassword: false }, token, refreshToken);
      }
      navigate('/');
    } catch (err: any) {
      setError(err?.response?.data?.error?.message ?? 'No se pudo cambiar la contraseña');
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-4">
      <div className="w-full max-w-md rounded-lg border border-border bg-white p-8 shadow-sm">
        <h1 className="text-2xl font-bold text-font-primary">
          {forced ? 'Cambia tu contraseña' : 'Actualizar contraseña'}
        </h1>
        <p className="mt-2 text-sm text-font-secondary">
          {forced
            ? 'Por seguridad, debes establecer una nueva contraseña antes de continuar.'
            : 'Actualiza tu contraseña actual por una nueva.'}
        </p>

        <form onSubmit={handleSubmit} className="mt-6 flex flex-col gap-4">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-font-primary">
              Contraseña actual
            </label>
            <input
              type="password"
              required
              value={currentPassword}
              onChange={(e) => setCurrent(e.target.value)}
              className="input h-11"
            />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-font-primary">
              Nueva contraseña
            </label>
            <input
              type="password"
              required
              value={newPassword}
              onChange={(e) => setNew(e.target.value)}
              className="input h-11"
              placeholder="Mínimo 8 caracteres"
            />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-font-primary">
              Confirmar nueva contraseña
            </label>
            <input
              type="password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="input h-11"
            />
          </div>
          {error && (
            <div className="rounded-md bg-red-50 px-3 py-2 text-sm text-error">{error}</div>
          )}
          <button
            type="submit"
            disabled={mut.isPending}
            className="mt-2 flex h-11 items-center justify-center rounded-md bg-primary text-sm font-semibold text-white hover:bg-primary-dark disabled:opacity-60"
          >
            {mut.isPending ? 'Guardando...' : 'Guardar nueva contraseña'}
          </button>
        </form>
      </div>
    </div>
  );
}
